<template>
  <div>
    <el-drawer
      title="选择商品"
      :visible.sync="dialogVisible"
      direction="rtl"
      :wrapperClosable="true"
      custom-class="drawer-box"
      size="1100px"
      :withHeader="false"
      @closeDrawer="handleClose"
      :before-close="handleClose">
      <div class="container">
        <div class="title-container">
          <div class="title">选择商品</div>
          <div>
            <el-form :model="searchForm" class="search-form" ref="searchFormRef">
              <el-form-item label="" prop="searchContent">
                <el-input
                  style="width:200px"
                  v-model="searchForm.searchContent"
                  placeholder="请输入商品名称/ID"
                />
              </el-form-item>
              <el-form-item>
                <!-- 操作按钮 -->
                <el-button :loading="table.loading" type="warning" @click="onFormSearch">查询</el-button>
                <el-button type="warning" plain @click="onFormReset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="table-container">
          <el-table
            ref="table"
            v-loading="table.loading"
            :data="table.dataSource"
            border
            fit
            highlight-current-row
            style="width: 100%"
            :header-cell-class-name="cellClass"
            @selection-change="onSelectionChange"
            row-key="thirdProductId"
            @select-all="changeSelectAll"
            @select="changeSelect"
          >
            <el-table-column :selectable="selectable" type="selection" width="55" align="center" />
            <el-table-column
              v-for="(item, index) in tableColumn"
              :key="index"
              :prop="item.value"
              :label="item.text"
              :fixed="item.fixed"
              :align="item.align ? item.align : 'center'"
              :width="item.width"
            >
<!--              <template slot="header" slot-scope="{}">-->
<!--                {{item.text}}-->
<!--              </template>-->
              <template slot-scope="{ row }">
                <div v-if="item.value === 'name'" style="display: flex; font-size: 12px;">
                  <div style="margin-right: 10px;">
                    <el-image
                      style="width: 50px; height: 50px;"
                      :src="row.productCover"
                      fit="fill"></el-image>
                  </div>
                  <div>
                    <div>{{row.productName}}</div>
                    <div>ID：{{row.thirdProductId}}</div>
                  </div>
                </div>
                <div v-else>{{row[item.value] ? row[item.value] :'-'}}</div>
              </template>
<!--              <template v-else slot-scope="{ row }">-->
<!--                <span>{{ row[item.value] }}</span>-->
<!--              </template>-->
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          v-if="table.total > 0"
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageNo"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="table.total"
        >
        </el-pagination>
        <div class="btns-coantainer">
          <div>
            <div v-if="table.total">
              已选择：{{idsCheck.length}} / 50
            </div>
          </div>
          <div>
            <el-button type="warning" plain @click="onCancel">取消</el-button>
            <el-button type="warning" @click="submit"
            >确认推广</el-button
            >
          </div>
        </div>
      </div>
    </el-drawer>
    <addExpertPop
      v-if="addExpertPopVisible"
      v-model="addExpertPopVisible"
      @close="addExpertPopVisible = false"
      @expertSubmit="handleExpertSubmit"
    ></addExpertPop>
    <manageDetailPop ref="manageDetailPopRef" @refresh="handleRefresh"></manageDetailPop>
  </div>

</template>

<script>
import mini from "@/api/mini";
const MiniModel = new mini();
import debounce from "@/utils/debounce.js";
import addExpertPop from './addExpertPop.vue'
import manageDetailPop from "./manageDetailPop.vue";
export default {
  name: "addPlan",
  components: {
    manageDetailPop,
    addExpertPop
  },
  data() {
    return {
      addExpertPopVisible:false,
      searchForm: {
        searchContent: '',
      },
      dialogVisible: false,
      submitLoading: false,
      tableColumn:[
        {
          value: 'name',
          text: '商品信息',
          // width: '300',
          align: 'left',
        },
        {
          value: 'isPromoteStr',
          text: '是否可推广',
          width: '200',
        },
        {
          value: 'notPromoteReason',
          text: '不可推广原因',
          width: '300',
        },
      ],
      table:{
        loading: false,
        dataSource: [],
        total: 0,
      },
      pagination: {
        // 分页
        pageSize: 10, // 表格分页页数
        pageNo: 1 // 表格当前页数
      },
      idsCheckRow: [], ////选中的row集合
      idsCheck: [], //选中的id集合
      tableSelectRows: [], // 选择项
      pageSizesArr: [10, 20, 30, 50, 500],
    }
  },
  watch: {
    'table.dataSource': {
      handler(newVal, oldVal) {
        // console.log(newVal.length,newVal[0].thirdProductId,'newVal-list')
        newVal.forEach((item) => {
          this.isSelectRow(item)
        })
      },
      deep: true
    }
  },
  created() {

  },
  methods:{
    cellClass() {
      return "DisableSelection";
    },
    handleRefresh() {
      console.log('handleRefresh===112')
      this.$emit('refresh')
      this.reset()
      this.getList()
    },
    handleExpertSubmit(list) {
      console.log(list,'handleExpertSubmithandleExpertSubmit===添加达人')
    },
    // 禁用勾选
    selectable(row,index) {
      // console.log(row,index,'row,indexrow,index')
      if(!row.isPromote) {
        return false
      }else{
        return true
      }
    },
    async getList() {
      this.table.loading = true
      const res = await MiniModel.dyLifePlanGoodsList({
        ...this.searchForm,
        ...this.pagination,
        appKey:localStorage.getItem("appKeyMini"),
      })
      this.table.loading = false
      console.log(res, 'getList==22233')
      if(res.data.code !== 200) {
        this.$message.error(res.data.message)
        return
      }
      if (res.data.code === 200) {
        let list = res.data.data.list.map(item => {
          return {
            ...item,
            thirdProductId: String(item.thirdProductId)
          }
        })
        // this.table.dataSource = [...this.table.dataSource,...list]
        this.table.dataSource = list
        this.table.total = res.data.data.total
      }
    },
    // 表格批量操作
    onSelectionChange(rows) {
      this.tableSelectRows = rows
    },
    // table自带全选
    changeSelectAll(selectionRow) {
      // 勾选当页全选
      if (this.$refs.table.store.states.isAllSelected) {
        // console.log('table勾选当页全选')
        selectionRow.forEach((item) => {
          if (!this.idsCheck.includes(item.thirdProductId)) {
            this.idsCheck.push(item.thirdProductId)
            this.idsCheckRow.push(item)
          }
        })
      } else {
        // console.log('table取消当页全选')
        // 取消当页全选
        this.table.dataSource.forEach((item) => {
          // 包含就删除
          let index = this.idsCheck.indexOf(item.thirdProductId)
          if (index !== -1) {
            this.idsCheck.splice(index, 1)
            this.idsCheckRow.splice(index, 1)
          }
        })
      }
      // console.log(selectionRow,this.$refs.multipleTable.store.states.isAllSelected,'table自带单页全选')
    },
    // 单行选中
    changeSelect(selection, row) {
      // console.log(selection, row.thirdProductId,'单行选中')
      // true就是选中，0或者false是取消选中
      let selected = selection.length && selection.indexOf(row) !== -1
      // 点击当前行的id
      let thirdProductId = row.thirdProductId
      if (selected) {
        // 选中
        // console.log('单行勾选'+thirdProductId)
        this.idsCheck.push(thirdProductId)
        this.idsCheckRow.push(row)
      } else {
        // 取消勾选
        // console.log('单行取消勾选'+thirdProductId)
        let index = this.idsCheck.indexOf(thirdProductId)
        if (index !== -1) {
          this.idsCheck.splice(index, 1)
          this.idsCheckRow.splice(index, 1)
        }
      }
    },
    // 勾选框
    isSelectRow(row) {
      if (this.idsCheck.includes(row.thirdProductId)) {
        this.$nextTick(() => {
          this.$refs.table.toggleRowSelection(row, true)
        })
      }
    },
    submit() {
      if(!this.idsCheck.length) {
        this.$message.error('请选择推广商品')
        return
      }
      if(this.idsCheck.length > 50) {
        this.$message.error('最多选择50个商品')
        return
      }
      console.log(this.idsCheckRow,'idsCheckRowidsCheckRow')
      this.$refs.manageDetailPopRef.open(1,this.idsCheckRow)
    },
    onCancel() {
      this.dialogVisible = false;
    },
    handleClose() {
      console.log("右上角取消==1");
      this.dialogVisible = false
    },
    reset() {
      this.pagination.pageNo = 1;
      this.pagination.pageSize = 10;
      this.searchForm = {
        searchContent: '',
      };
      this.table.dataSource = [];
      this.table.total = 0;
      this.idsCheckRow = [];
      this.idsCheck = [];

    },
    open(row) {
      this.reset()
      this.dialogVisible = true
      this.getList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pagination.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pagination.pageNo = val;
      this.getList();
    },
    onFormSearch() {
      debounce(
        () => {
          this.table.dataSource = [];
          this.table.total = 0;
          this.pagination.pageNo = 1;
          this.getList();
          // this.$refs['searchFormRef'].validate((valid) => {
          //   if (valid) {
          //     this.pagination.pageNo = 1;
          //     this.getList();
          //   } else {
          //     console.log('error submit!!');
          //     return false;
          //   }
          // });
        },
        500,
        true
      );
    },
    onFormReset() {
      debounce(() => {
        this.searchForm = {
          searchContent: '',
        }
        this.$refs['searchFormRef'].resetFields();
        this.getList()
      }, 1000, true)
    },
  },
}
</script>

<style scoped lang="less">
/deep/.el-table .DisableSelection .cell .el-checkbox__inner {
  display: none;
}
.container{
  padding: 20px;
  height: 100%;
}
.btns-coantainer{
  position: absolute;
  bottom: 30px;
  z-index: 99;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-right: 60px;
}
.table-container{
  height: calc(100vh - 200px);
  overflow-y: auto;
  position: relative;
}
.title{
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
}
.title-container{
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/poiCps/components/addPlanPop.vue